import React, { useState, useEffect } from "react";

function ExplanationItem(props) {
  const { currentObject, handleChangeInput, indexParent } = props && props;

  //state
  const [stateData, setData] = useState(currentObject || {});

  //load
  useEffect(() => {
    setData(currentObject || {});
  }, [currentObject]);

  return (
    <input
      type="number"
      name="Score"
      className="form-control m-input"
      value={stateData?.Score}
      data-index-parent={indexParent}
      onChange={handleChangeInput}
      step="any"
    />
  );
}

export default ExplanationItem;
